import { z } from "zod";
import { OTHER_VALUES, DISSATISFIED_VALUES } from "./constants";

// その他が選ばれていて、かつ理由が未記入の場合は必須にする
const requireReasonIfSelectOther = ({
  questionsValues,
  otherValue,
  reasonValue,
}: {
  questionsValues: string[];
  otherValue: string;
  reasonValue: string | undefined;
}): boolean => {
  const isSelectedOther = questionsValues.includes(otherValue);
  const isReasonEmpty = !reasonValue || reasonValue.trim().length === 0;
  return !(isSelectedOther && isReasonEmpty);
};

// 不満、どちらかといえば不満を選んでいる場合は理由の記入を必須にする
const requireReasonIfNotSatisfied = ({
  satisfactionValue,
  notSatisfiedValues,
  reasonValue,
}: {
  satisfactionValue: string | null;
  notSatisfiedValues: string[];
  reasonValue: string[];
}): boolean => {
  if (satisfactionValue === null) return true;
  const isNotSatisfied = notSatisfiedValues.includes(satisfactionValue);
  const isReasonEmpty = reasonValue.length === 0;
  return !(isNotSatisfied && isReasonEmpty);
};

export const schema = z
  .object({
    question1Answer: z
      .string()
      .nullable()
      .refine((val) => val !== null && val.length > 0, { message: "選択してください" }),
    question2Answer: z.string().min(1, "入力してください"),
    question3Answer: z
      .string()
      .nullable()
      .refine((val) => val !== null && val.length > 0, { message: "選択してください" }),
    question4Answer: z.array(z.string()).min(1, "選択してください"),
    question4AnswerOthersText: z.string().optional(),
    question5Answer: z
      .string()
      .nullable()
      .refine((val) => val !== null && val.length > 0, { message: "選択してください" }),
    question5SubAnswer: z.array(z.string()),
    question5SubAnswerOthersText: z.string().optional(),
    question6Answer: z
      .string()
      .nullable()
      .refine((val) => val !== null && val.length > 0, { message: "選択してください" }),
    question6SubAnswer: z.array(z.string()),
    question6SubAnswerOthersText: z.string().optional(),
    question7Answer: z
      .string()
      .nullable()
      .refine((val) => val !== null && val.length > 0, { message: "選択してください" }),
    question7SubAnswer: z.array(z.string()),
    question7SubAnswerOthersText: z.string().optional(),
    question8Answer: z
      .string()
      .nullable()
      .refine((val) => val !== null && val.length > 0, { message: "選択してください" }),
    question8SubAnswer: z.array(z.string()),
    question8SubAnswerOthersText: z.string().optional(),
    question9Answer: z.array(z.string()).min(1, "選択してください"),
    question9AnswerOthersText: z.string().optional(),
    question10Answer: z
      .string()
      .nullable()
      .refine((val) => val !== null && val.length > 0, { message: "選択してください" }),
    question11Answer: z.string().min(1, "入力してください"),
  })
  .check((ctx) => {
    const v = ctx.value;

    if (
      !requireReasonIfSelectOther({
        questionsValues: v.question4Answer,
        otherValue: OTHER_VALUES.question4,
        reasonValue: v.question4AnswerOthersText,
      })
    ) {
      ctx.issues.push({
        code: "custom",
        path: ["question4AnswerOthersText"],
        message: "入力してください",
        input: v,
      });
    }

    if (
      !requireReasonIfNotSatisfied({
        satisfactionValue: v.question5Answer,
        notSatisfiedValues: DISSATISFIED_VALUES.question5,
        reasonValue: v.question5SubAnswer,
      })
    ) {
      ctx.issues.push({
        code: "custom",
        path: ["question5SubAnswer"],
        message: "選択してください",
        input: v,
      });
    }

    if (
      !requireReasonIfSelectOther({
        questionsValues: v.question5SubAnswer,
        otherValue: OTHER_VALUES.question5Sub,
        reasonValue: v.question5SubAnswerOthersText,
      })
    ) {
      ctx.issues.push({
        code: "custom",
        path: ["question5SubAnswerOthersText"],
        message: "入力してください",
        input: v,
      });
    }

    if (
      !requireReasonIfNotSatisfied({
        satisfactionValue: v.question6Answer,
        notSatisfiedValues: DISSATISFIED_VALUES.question6,
        reasonValue: v.question6SubAnswer,
      })
    ) {
      ctx.issues.push({
        code: "custom",
        path: ["question6SubAnswer"],
        message: "選択してください",
        input: v,
      });
    }

    if (
      !requireReasonIfSelectOther({
        questionsValues: v.question6SubAnswer,
        otherValue: OTHER_VALUES.question6Sub,
        reasonValue: v.question6SubAnswerOthersText,
      })
    ) {
      ctx.issues.push({
        code: "custom",
        path: ["question6SubAnswerOthersText"],
        message: "入力してください",
        input: v,
      });
    }

    if (
      !requireReasonIfNotSatisfied({
        satisfactionValue: v.question7Answer,
        notSatisfiedValues: DISSATISFIED_VALUES.question7,
        reasonValue: v.question7SubAnswer,
      })
    ) {
      ctx.issues.push({
        code: "custom",
        path: ["question7SubAnswer"],
        message: "選択してください",
        input: v,
      });
    }

    if (
      !requireReasonIfSelectOther({
        questionsValues: v.question7SubAnswer,
        otherValue: OTHER_VALUES.question7Sub,
        reasonValue: v.question7SubAnswerOthersText,
      })
    ) {
      ctx.issues.push({
        code: "custom",
        path: ["question7SubAnswerOthersText"],
        message: "入力してください",
        input: v,
      });
    }

    if (
      !requireReasonIfNotSatisfied({
        satisfactionValue: v.question8Answer,
        notSatisfiedValues: DISSATISFIED_VALUES.question8,
        reasonValue: v.question8SubAnswer,
      })
    ) {
      ctx.issues.push({
        code: "custom",
        path: ["question8SubAnswer"],
        message: "選択してください",
        input: v,
      });
    }

    if (
      !requireReasonIfSelectOther({
        questionsValues: v.question8SubAnswer,
        otherValue: OTHER_VALUES.question8Sub,
        reasonValue: v.question8SubAnswerOthersText,
      })
    ) {
      ctx.issues.push({
        code: "custom",
        path: ["question8SubAnswerOthersText"],
        message: "入力してください",
        input: v,
      });
    }

    if (
      !requireReasonIfSelectOther({
        questionsValues: v.question9Answer,
        otherValue: OTHER_VALUES.question9,
        reasonValue: v.question9AnswerOthersText,
      })
    ) {
      ctx.issues.push({
        code: "custom",
        path: ["question9AnswerOthersText"],
        message: "入力してください",
        input: v,
      });
    }
  });

export type InputProps = z.infer<typeof schema>;
